var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M194.5,103.1c0-2.2-1.8-4-4-4H77.7l19.3-19.7c1.6-1.6,1.5-4.1,0-5.7c-1.6-1.6-4.1-1.5-5.7,0l-32.8,33.4h131.9C192.7,107.1,194.5,105.3,194.5,103.1L194.5,103.1z M57.2,155.5c0,2.2,1.8,4,4,4h113.6l-19.7,19.6c-1.6,1.6-1.6,4.1,0,5.7c0.8,0.8,1.8,1.2,2.9,1.2s2.1-0.4,2.9-1.2l33.4-33.4H61.3C59,151.5,57.2,153.3,57.2,155.5L57.2,155.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M128,246c65.1,0,118-52.9,118-118c0-65.1-52.9-118-118-118C62.9,10,10,62.9,10,128C10,193.1,62.9,246,128,246L128,246z M128,22c58.4,0,106,47.6,106,106c0,58.4-47.6,106-106,106c-58.4,0-106-47.6-106-106C22,69.6,69.6,22,128,22L128,22z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.c11fc350c69898a17f1fbabf5ebc2533.svg";
export { ForwardRef as ReactComponent };